import { COOKIE_HEADER_KEY } from '@/configs/serviceConstants';

const generateHttpHeaders = (cookies?: any) => {
  let headers: { [key: string]: any } = { 'content-type': 'application/json', client: 'web' };
  cookies && typeof window === 'undefined' && (headers[COOKIE_HEADER_KEY] = cookies);
  return headers;
};

export default generateHttpHeaders;
